import React from 'react';
import { Check, ChevronRight, Flag, Plus, SkipForward, Trash2 } from 'lucide-react';
import Sheet from './Sheet';
import { safeMediaUrl, supersetOf, workSets } from './playerLogic';

// A lista de exercícios do treino: onde se está, o que já se fez, e saltar para qualquer um. É também de onde se conclui ou abandona o
// treino — nunca de um botão solto no ecrã do exercício, para ninguém o fazer sem querer.

const statusLabel = { Completed: 'Concluído', Skipped: 'Saltado', InProgress: 'Em curso', Pending: 'Por fazer' };

export default function ExerciseListSheet({ open, exercises, index, onJump, onClose, onFinish, onAbandon, onAdd, canFinish, canAdd = true }) {
  return (
    <Sheet open={open} onClose={onClose} title="Exercícios do treino" testId="exercise-list">
      <ol className="wp-list-ex">
        {exercises.map((e, i) => {
          const logged = workSets(e).length;   // o aquecimento não é uma série registada
          const target = e.prescription?.setsTarget;
          const img = safeMediaUrl(e.imageUrl);
          // Um exercício que não veio do plano (acrescentado por quem treina) não tem prescrição nenhuma.
          const added = !e.plannedLibraryExerciseId && !!e.executedLibraryExerciseId;
          return (
            <li key={e.id ?? i}>
              <button type="button" className={`wp-ex-row ${i === index ? 'is-current' : ''} status-${e.status}`} onClick={() => { onJump(i); onClose(); }} aria-current={i === index ? 'step' : undefined} data-testid={`list-ex-${i}`}>
                <span className="wp-ex-thumb" aria-hidden="true">
                  {img ? <img src={img} alt="" loading="lazy" data-testid={`list-ex-img-${i}`} /> : null}
                  {e.status === 'Completed' ? <span className="wp-ex-tick"><Check size={14} strokeWidth={3} /></span>
                    : e.status === 'Skipped' ? <span className="wp-ex-tick"><SkipForward size={12} /></span>
                      : img ? null : <span className="wp-ex-badge">{i + 1}</span>}
                </span>
                <span className="wp-ex-text">
                  <span className="wp-ex-name">
                    {supersetOf(exercises, i) ? <span className="wp-group-badge">{supersetOf(exercises, i).label}</span> : null}
                    {e.name}{e.wasSubstituted ? <span className="wp-ex-sub"> · substituído</span> : null}{added ? <span className="wp-ex-sub"> · acrescentado</span> : null}
                  </span>
                  <span className="wp-ex-meta">{statusLabel[e.status] || e.status} · {logged}{target ? ` / ${target}` : ''} séries{added && !target ? ' (sem prescrição)' : ''}</span>
                </span>
                <ChevronRight size={18} aria-hidden="true" className="wp-ex-go" />
              </button>
            </li>
          );
        })}
      </ol>

      <div className="wp-list-actions">
        <button type="button" className="wp-btn wp-btn-ghost" onClick={onAdd} disabled={!canAdd} data-testid="open-add"> <Plus size={18} aria-hidden="true" /> Adicionar exercício…</button>
        <button type="button" className="wp-btn wp-btn-primary wp-btn-xl" onClick={onFinish} disabled={!canFinish} data-testid="open-finish">
          <Flag size={20} aria-hidden="true" /> Concluir treino…
        </button>
        {!canFinish ? <p className="wp-note wp-center">Registe pelo menos uma série para poder concluir.</p> : null}
        <button type="button" className="wp-link-btn wp-danger-link" onClick={onAbandon} data-testid="open-abandon"><Trash2 size={15} aria-hidden="true" /> Abandonar treino…</button>
      </div>
    </Sheet>
  );
}
